/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiHandler } from "@insite/client-framework/HandlerCreator";
import { GetDealersApiParameter } from "@insite/client-framework/Services/DealerService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Dealers/Handlers/LoadDealers";
import { DealerCollectionModel } from "@insite/client-framework/Types/ApiModels";

interface XGetDealersApiParameter extends GetDealersApiParameter {
    populateDealerTypes: boolean;
}
type HandlerType = ApiHandler<XGetDealersApiParameter, DealerCollectionModel>;

export const XngPopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
        populateDealerTypes: true,
    };
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
